/* @flow */

import classNames from 'classnames';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';

import styles from './Steps.style';

type Props = {
  className?: string,
  activeStepIndex?: number,
  children: React.Node,
  initial?: number,
  onChange?: (index: number) => void,
};

const useStyles = createUseThemeStyles(styles);

const Steps = ({
  className,
  activeStepIndex,
  children,
  initial = 0,
  onChange,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles();
  const rootClasses = classNames([classes.root, className]);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  const onStepClick = (next: number) => {
    if (onChange && activeStepIndex !== next) {
      onChange(next);
    }
  };
  const childArray = React.Children.toArray(children);
  return (
    <ol className={rootClasses}>
      {childArray.map((child, index) => {
        const stepNumber = initial + index;
        const childProps = {
          stepNumber: `${stepNumber + 1}`,
          stepIndex: stepNumber,
          key: stepNumber,
          isActive: stepNumber === activeStepIndex,
          isLastStep: stepNumber === childArray.length - 1,
          onClick: onChange && onStepClick,
          ...child.props,
        };
        return React.cloneElement(child, childProps);
      })}
    </ol>
  );
};

export default React.memo<Props>(Steps);
